var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMHat3WHair5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 720 720",
    enableBackground: "new 0 0 720 720",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "frame_730px"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4.8,
    y: -4.9,
    fill: "none",
    stroke: "#0000FF",
    strokeWidth: 0.25,
    strokeOpacity: 0,
    width: 730,
    height: 730
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "w-hair5_1_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D0E09B",
    d: "M486.5,46.1c-4.2-1.6-8.5-3.1-12.7-4.5c-6.4-2-12.9-3.8-19.4-5.3s-13-3-19.4-4.4 c-44.4-7.5-88.4-7.5-132.5,0.6c-5.7,1.1-11.3,2.3-16.8,3.7c-51.1,13.1-104.1,44.1-123.5,95.6c-1.7,4.5-3,9.2-4,13.8 c-4,18.6-2.2,37.7,8.3,54.1c0,0.3,0,0.7,0.1,1c19.9,26.2,47.9,46.6,80.4,54.3c0.2-0.1,0.4-0.2,0.6-0.3 c-22.9-25.2-26.6-60.2-14.1-82h0.1c28.1-9.3,60.3-16.1,106-20l87.5,2.5c18.5-0.4,33,3.2,44.6,9.1l-9.1,6.4 c32.7,16.2,46.8,58.7,35.5,96c6.1-6.6,14-16.9,20.9-28.1c9.6-11.4,21.5-29,27-42.9c1.9-4.8,3.5-9.6,4.9-14.6 C569.5,128.5,541.5,63.5,486.5,46.1z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "hats_w-hair5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m-hat3_5_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6F3C1B",
    d: "M531,140.8c-1.2-17.9-32.5-18.2-46.3-19.2c-40.3-2.8-79.6,4.6-120.8,4.3c-28.9-0.2-59.6-3.2-91-5.9 l-3.7-0.5c-12.3-1.8-34.2,1.1-46.8,4.3c-14.7,3.7-35,14.5-23.9,33c7.1,11.9,30.7,26.3,43.1,31.4c16.6,6.8,29.4,11.2,46.8,15.3 c34.8,8.1,70.9,5,105.9,0.7c35.7-4.4,70.4-12,103.3-28.6C510.3,169,532.2,157.9,531,140.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6F3C1B",
    d: "M441.8,64.4c-9.5-4.8-21.5-7.5-31.2-11.7c-10-4.4-15.3-12.6-24.9-18.4c-20.8-12.4-50.9,2.8-68.7,14.8 c-22.7,15.3-37.9,5.1-53.2,24.5c-7.4,9.3-8.2,23.2-8.5,34.8c-0.2,7.1,0.4,18.7,1.2,29.2c1.4,0.9,2.7,1.8,4.1,2.6 c54.5,32.6,126.8,35.8,185.7,10.2c5.7-2.6,11.2-5.5,16.6-8.7c1.4-0.8,2.7-1.7,4.1-2.5c-0.2-4.4-0.4-8.4-0.6-11.2 C464.1,104,466.6,76.9,441.8,64.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#CCB37F",
    d: "M464.8,106.9c-0.9,0.4-1.7,0.8-2.6,1.2c-5.6,2.5-11.2,4.8-17,6.9c-56.8,19.4-120.7,18.4-176-4.5 c-4.7-2-9.3-4.1-13.8-6.3c-0.1,1.4-0.1,2.7-0.1,4.1c-0.2,7.1,0.4,18.7,1.2,29.2c1.4,0.9,2.7,1.8,4.1,2.6 c54.5,32.6,126.8,35.8,185.7,10.2c5.7-2.6,11.2-5.5,16.6-8.7c1.4-0.8,2.7-1.7,4.1-2.5c-0.2-4.4-0.4-8.4-0.6-11.2 C465.6,121,465.4,113.9,464.8,106.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#41210D",
    d: "M365,85.5c20.6-3.2,34.7-16.9,47-32.2c-0.5-0.2-1-0.4-1.4-0.6c-10-4.4-15.3-12.6-24.9-18.4 c-20.8-12.4-50.9,2.8-68.7,14.8c-3.9,2.7-7.7,4.6-11.2,6c1.2,2.2,2.5,4.3,4,6.3C321.4,79.1,343.7,88.6,365,85.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#41210D",
    d: "M466.9,139c-0.2-4.4-0.4-8.4-0.6-11.2c-1.9-21-0.2-44.6-16.8-58.5c-5.7,25.7,0.7,51.9,3.7,77.5 c3.3-1.7,6.5-3.5,9.7-5.4C464.2,140.7,465.5,139.9,466.9,139z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#41210D",
    d: "M288.4,89.7c38.3,23.5,94.7,24.5,132-2.1c-12.8,25.5-53,28.9-78.6,26.8 C319.4,112.2,305.4,105.7,288.4,89.7"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFE7B6",
    d: "M332.6,126.9c-7.1,11.1-12.8,21-22.5,33.8c3.5,0.9,7.1,1.7,10.7,2.4c10.2-13.3,15.8-23.5,23.4-35.1 C340.3,127.7,336.4,127.3,332.6,126.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFE7B6",
    d: "M379.5,128.1c-8.5,12.7-18.3,27.4-28.3,38.9c14.6,0.8,29.4,0.1,43.8-2.1c8.6-13,16.6-28.9,23.6-42.4 C405.8,125.3,392.7,127.2,379.5,128.1z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMHat3WHair5);
export default __webpack_public_path__ + "static/media/m-hat3_w-hair5.5a63b51a9f2e345c1f6cb986947e3f18.svg";
export { ForwardRef as ReactComponent };